import axios from 'axios';
import { buildLoginUrl, savePostLoginRedirect } from '../utils/authRedirect';
import {
    isBackendConnectivityFailure,
    reportApiConnectivityFailure,
    reportApiConnectivityOk,
} from './apiHealth';
import { getFmsLayoutLocale, isFmsLayoutLocaleGetRequest } from '../assets/utils/comm/fmsLayoutLocale';

// setupProxy.js 가 설정되어 있으므로 브라우저 호스트와 동일한 상대경로를 사용합니다.
const baseURL = '';

// Axios 기본 인스턴스 생성
const Http = axios.create({
    baseURL: baseURL,
    timeout: 10000,
    withCredentials: true, // JWT 쿠키(Authorization) 자동 전송
    headers: {
        'Content-Type': 'application/json',
    },
});

// 요청(Request) 인터셉터
Http.interceptors.request.use(
    (config) => {
        if (isFmsLayoutLocaleGetRequest(config.url, config.method)) {
            const locale = getFmsLayoutLocale();
            const url = String(config.url || '');
            const hasInUrl = /(?:\?|&)locale=/.test(url);
            const hasInParams = config.params != null && config.params.locale != null && config.params.locale !== '';
            if (!hasInUrl && !hasInParams) {
                config.params = { ...(config.params || {}), locale };
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 응답(Response) 인터셉터
Http.interceptors.response.use(
    (response) => {
        reportApiConnectivityOk();
        // 성공 시 응답 데이터(payload)만 깔끔하게 반환 (호출부에서 res.data.data 이렇게 안 해도 됨)
        return response.data;
    },
    (error) => {
        if (isBackendConnectivityFailure(error)) {
            reportApiConnectivityFailure(error);
        }

        if (error.response) {
            const { status, data } = error.response;

            if (status === 401) {
                console.warn('인증이 만료되었거나 올바르지 않습니다.', data);
                const requestUrl = String(error.config?.url || '');
                const skipAuthRedirect =
                    error.config?.skipAuthRedirect === true ||
                    requestUrl.includes('/api/login') ||
                    requestUrl.includes('/api/glow/user/me') ||
                    requestUrl.includes('/api/glow/user/logout') ||
                    requestUrl.includes('/api/glow/otp') ||
                    requestUrl.includes('/api/glow/user/change-password');

                // Stateless JWT + SPA 구조라 현재 경로를 기억했다가 로그인 후 다시 이동시킨다.
                if (!skipAuthRedirect && typeof window !== 'undefined' && window.location.pathname !== '/login') {
                    savePostLoginRedirect();
                    window.location.assign(buildLoginUrl());
                }
            } else if (status === 403) {
                console.warn('해당 리소스에 접근할 권한이 없습니다.', data);
                // alert('해당 기능을 사용할 권한이 없습니다.');
            } else {
                console.error(`[API Error] 상태코드: ${status}, 메세지:`, data);
            }
        } else {
            console.error('서버와 연결할 수 없거나 네트워크 에러입니다.', error.message);
        }

        return Promise.reject(error);
    }
);

export default Http;
